import React from 'react';
import { useLocation } from 'react-router-dom';
import NavTabs from '@dashboard/components/NavTabs';

const TABS = [
  { key: 'blocks', label: 'Blocks', to: '/link-in-bio' },
  { key: 'socials', label: 'Social links', to: '/link-in-bio?tab=socials' },
  { key: 'profile', label: 'Profile', to: '/link-in-bio?tab=profile' },
  { key: 'theme', label: 'Theme', to: '/link-in-bio?tab=theme' },
] as const;

export type LinkInBioTab = (typeof TABS)[number]['key'];

export const useLinkInBioTab = (): LinkInBioTab => {
  const asked = new URLSearchParams(useLocation().search).get('tab');
  return TABS.find(tab => tab.key === asked)?.key ?? 'blocks';
};

export default function LinkInBioTabs() {
  const tab = useLinkInBioTab();
  return (
    <NavTabs aria-label="Link in bio">
      {TABS.map(({ key, label, to }) => (
        <NavTabs.Item key={key} to={to} active={tab === key}>
          {label}
        </NavTabs.Item>
      ))}
    </NavTabs>
  );
}
